import React from 'react';
import { Link } from 'react-router-dom';
import { readyToBuyPieces } from '../utils/mockData';
import { useContent, resolveAsset } from '../contexts/ContentContext';
import ProductGrid from './ProductGrid';

const mapDb = (p) => ({
  id: p.id,
  type: p.type,
  name: p.name,
  description: p.description,
  technique: p.embroidery || 'Bespoke',
  material: p.fabric || 'Pure Silk',
  price: p.price,
  image: resolveAsset(p.image),
});

const ReadyToBuy = () => {
  const { products, content } = useContent();
  const section = content['home.readytowear'] || {};

  const rtw = products.filter((p) => p.type === 'ready-to-wear' && p.price != null);
  // Featured first, then non-featured fill — every uploaded RTW piece is shown (capped at 4).
  const featured = rtw.filter((p) => p.featured).map(mapDb);
  const rest = rtw.filter((p) => !p.featured).map(mapDb);
  const ordered = [...featured, ...rest];
  const items = (ordered.length ? ordered : readyToBuyPieces).slice(0, 4);

  return (
    <section
      id="ready-to-buy"
      className="section-padding"
      style={styles.section}
      data-testid="ready-to-buy-section"
    >
      <div className="luxury-container">
        <div style={styles.sectionHeader}>
          <p style={styles.sectionLabel}>{section.eyebrow || 'Ready to Wear'}</p>
          <h2 className="heading-1">{section.title || 'Shop the Atelier'}</h2>
          <p className="body-large" style={styles.sectionDescription}>
            {section.description || 'A curated edit of hand-finished pieces, ready to ship worldwide'}
          </p>
        </div>

        <ProductGrid
          items={items}
          variant="ready"
          testIdPrefix="rtb"
        />

        <div style={styles.ctaWrap}>
          <Link to="/shop" className="btn-secondary" data-testid="rtb-view-all">
            {section.viewAllText || 'View All Ready to Wear'}
          </Link>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: 'var(--bg-primary)',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '60px',
  },
  sectionLabel: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '16px',
  },
  sectionDescription: {
    maxWidth: '600px',
    margin: '16px auto 0',
  },
  ctaWrap: {
    marginTop: '56px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export default ReadyToBuy;
